import { toast } from 'react-toastify';

export const toastError = (error) =>
    toast.error(error, {
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: true
    });

export const toastAlert = (error) =>
    toast.info(error, {
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: true
    });

export const toastWarn = (error) =>
    toast.warn(error, {
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: true
    });

export const toastSuccess = (error) =>
    toast.success(error, {
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: true
    });
